import React, { useState, useEffect, Children } from 'react';
import { any, number, func } from 'prop-types';
import './Switch.scss';
import bem from '../../utils/bem';

const Switch = ({ children, initial = 0, onChange }) => {
    const [selected, setSelected] = useState(initial);
    const handleOnChange = (index) => {
        setSelected(index);
        onChange(index)
    }
    useEffect(() => {
        onChange(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const count = Children.count(children);
  return (
    <div className={bem('switch', {
      'only-child': count <= 1
    })}>
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child, {
          onClick: () => handleOnChange(index),
          isSelected: selected === index,
        });
      })}
    </div>
  );
};

Switch.propTypes = {
  children: any,
  initial: number,
  onChange: func,
};

export default Switch;
